"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Background() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="professional-background" ref={sectionRef} className={`bg-background text-foreground py-14 md:py-20 lg:py-24 border-b border-border transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Portrait Image Frame flush with border */}
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded border border-border bg-card">
              <img src="https://ablazecontractingservicellc.com/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-22-at-03.43.28-1.jpeg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/WhatsApp Image 2026-06-22 at 03.43.28.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685663/img/WhatsApp Image 2026-06-22 at 03.43.28.jpg-wvc-sizes" alt="Prince Owusu, manager of Ablaze Contracting Service LLC" loading="eager" decoding="async" className="w-full aspect-[4/5] object-cover block" />
            </div>
            <div className="mt-3 text-xs font-mono text-muted-foreground uppercase tracking-widest">
              Manager · Dumfries, Virginia
            </div>
          </div>

          {/* Bio text block */}
          <div className="lg:col-span-7 flex flex-col justify-start">
            <h1 className="font-serif font-normal text-3xl sm:text-4xl lg:text-5xl leading-[1.12] text-foreground tracking-tight border-l-4 border-primary pl-4 mb-6">
              Prince Owusu
            </h1>

            <p className="text-lg leading-relaxed text-foreground font-medium mb-4">
              General contractor serving Dumfries, Virginia and the surrounding area.
            </p>

            <div className="space-y-4 text-base leading-relaxed text-muted-foreground mb-8">
              <p>
                Prince manages day-to-day trade work and remodeling projects for homeowners and commercial properties across Dumfries and neighboring communities. Every project is scoped directly on-site with clear pricing, realistic timelines, and personal oversight from start to finish.
              </p>
              <p>
                Work spans interior renovations, finished carpentry, flooring, tiling, painting, and general property maintenance. You deal directly with the person responsible for getting the work done right.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 pt-4 border-t border-border">
              <Button asChild className="rounded h-11 px-6 font-medium text-sm">
                <Link to="/BookAppointmentPage">
                  Book an appointment
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" className="rounded h-11 px-6 border-border font-medium text-sm">
                <a href="tel:+15712496482" className="inline-flex items-center gap-2">
                  <Phone className="size-4 text-primary" />
                  <span>Call +1 (571) 249-6482</span>
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}